var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonicIosArrowRoundBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10.401,
    viewBox: "0 0 15 10.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M12.954,11.43a.635.635,0,0,1,0,.895l-2.952,2.961H21.255a.632.632,0,0,1,0,1.264H10.007l2.957,2.961a.64.64,0,0,1,0,.895.63.63,0,0,1-.89,0L8.062,16.366h0a.71.71,0,0,1-.131-.2.6.6,0,0,1-.049-.243.634.634,0,0,1,.18-.443l4.007-4.036A.619.619,0,0,1,12.954,11.43Z",
    transform: "translate(-7.382 -10.752)",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosArrowRoundBack);
export default __webpack_public_path__ + "static/media/ionic-ios-arrow-round-back.fe5bb31a37798082d9aa2e3802da06c4.svg";
export { ForwardRef as ReactComponent };